<mat-card appearance="outlined" id="login-form-card">
  <mat-card-content>
    @if (isDemo) {
      <nav mat-tab-nav-bar>
        @for (link of navLinks; track link) {
          <a
            mat-tab-link
            id="{{ link.id }}"
            [routerLink]="link.path"
            routerLinkActive
            #rla="routerLinkActive"
            [active]="rla.isActive"
            >
            {{ link.label }}
          </a>
        }
      </nav>
    }
    @if (bannerStatus$ | async) {
      <mat-toolbar
        class="login-banner"
        color="{{ bannerColor$ | async }}"
        fxFlexFill
        >
        <span class="login-banner-message">
          {{ bannerMessage$ | async }}
        </span>
      </mat-toolbar>
    }
    @if (noTokenPresent && !isDemo) {
      <mat-toolbar
        class="login-banner"
        color="warn"
        fxFlexFill
        >
        <span class="login-banner-message">
          {{ noTokenMessage }}
        </span>
      </mat-toolbar>
    }
    @if (noTokenPresent && !isDemo) {
      <button
        (click)="returnToMyCL()"
        mat-flat-button
        fxLayoutAlign="center"
        [style]="'margin: 40px auto auto auto'"
        color="primary">
        Return to MyCL
      </button>
    }
    @if (!noTokenPresent) {
      <mat-progress-spinner
        fxLayoutAlign="center"
        mode="indeterminate"
        [style]="'margin: 40px auto auto auto'"
        >
      </mat-progress-spinner>
    }
    <div id="login-form-container">
      @if (isDemo && noTokenPresent) {
        <form
          novalidate
          id="login-form"
          [formGroup]="loginForm"
          (ngSubmit)="login()"
          >
          <mat-form-field>
            <input
              id="email"
              matInput
              placeholder="Email"
              formControlName="email"
              (keyup)="removeWhitespace($event)"
              required
              />
            @if (validate('email', 'required')) {
              <mat-error>
                Email is required
              </mat-error>
            }
            @if (
              validate('email', 'email') &&
              !validate('email', 'required')
              ) {
              <mat-error
                >
                Value must be a valid email
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="password"
              matInput
              placeholder="Enter your password"
              formControlName="password"
              [type]="hide ? 'password' : 'text'"
              (keyup)="markAsTouched($event)"
              required
              />
            <mat-icon
              id="login-password-icon"
              matSuffix
              fontSet="fa"
              fontIcon="{{ hide ? 'fa-eye-slash' : 'fa-eye' }}"
              (click)="hide = !hide"
              >
            </mat-icon>
            @if (validate('password', 'required')) {
              <mat-error>
                Password is required
              </mat-error>
            }
          </mat-form-field>
          <!--                <button-->
          <!--                    id="forgot-button"-->
          <!--                    type="button"-->
          <!--                    mat-raised-button-->
          <!--                    color="secondary"-->
          <!--                    (click)="forgotPassword(); (false)"-->
          <!--                    role="link"-->
          <!--                >-->
          <!--                    Forgot Password-->
        <!--                </button>-->
        <button
          id="login-button"
          type="submit"
          mat-raised-button
          fxFlexFill
          color="primary"
                    [disabled]="
                        loginForm.untouched ||
                        !loginForm.valid ||
                        maintenanceMode == true
                    "
          >
          Sign In
        </button>
      </form>
    }
  </div>
  <mat-toolbar id="support-toolbar">
    <button
      id="support-link"
      mat-button
      (click)="goToSupportForm()"
      role="link"
      >
      Contact Support
    </button>
  </mat-toolbar>
</mat-card-content>
</mat-card>
